export default __webpack_public_path__ + "static/media/meeting_small.5c45f425.svg";